import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

import { variants } from "../constants";

const updateName = "updateName";

export const twoFALoginKeys = createKeys(featureKeys.TWO_FA_LOGIN, {
  login: () => [variants.login],
  give: () => [variants.give],
  signupList: () => [variants.signupList],
  mmg: () => [variants.mmg],
  famReg: () => [variants.famReg],
  updateName: (userID) => [updateName, userID],
});
